import axios from "axios";
import {
  MY_CLAIM_LIST_REQUEST,
  MY_CLAIM_LIST_SUCCESS,
  MY_CLAIM_LIST_FAIL,
  CLAIM_STATS_REQUEST,
  CLAIM_STATS_SUCCESS,
  CLAIM_STATS_FAIL,
  CLAIM_SINGLE_REQUEST,
  CLAIM_SINGLE_SUCCESS,
  CLAIM_SINGLE_FAIL,
  CLAIM_PENDING_REQUEST,
  CLAIM_PENDING_SUCCESS,
  CLAIM_PENDING_FAIL,
  CLAIM_POST_REQUEST,
  CLAIM_POST_SUCCESS,
  CLAIM_POST_FAIL,
  CLAIM_UPDATE_REQUEST,
  CLAIM_UPDATE_SUCCESS,
  CLAIM_UPDATE_FAIL,
  CLAIM_DELETE_REQUEST,
  CLAIM_DELETE_SUCCESS,
  CLAIM_DELETE_FAIL,
} from "constants/claimConstants";
import { REACT_APP_API_URL } from "constants/apiConstants";
import ClaimsService from "services/claims-service";

export const getMyClaimsList = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: MY_CLAIM_LIST_REQUEST,
    });

    const res = await ClaimsService.getMyClaims();
    console.log("🚀 ~ file: claimActions.js:26 ~ getMyClaimsList ~ res:", res);

    dispatch({
      type: MY_CLAIM_LIST_SUCCESS,
      payload: res.foundClaims,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: claimActions.js:33 ~ getMyClaimsList ~ error:",
      error
    );
    dispatch({
      type: MY_CLAIM_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getClaimSingle = (claimId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLAIM_SINGLE_REQUEST,
    });

    const res = await ClaimsService.getClaimsSingle(claimId);
    console.log("🚀 ~ file: claimActions.js:63 ~ getClaimSingle ~ res:", res);

    dispatch({
      type: CLAIM_SINGLE_SUCCESS,
      payload: res.foundClaims,
    });
  } catch (error) {
    dispatch({
      type: CLAIM_SINGLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getClaimStats = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLAIM_STATS_REQUEST,
    });

    const res = await ClaimsService.getClaimsStats();
    console.log("🚀 ~ file: claimActions.js:86 ~ getClaimStats ~ res:", res);

    dispatch({
      type: CLAIM_STATS_SUCCESS,
      payload: res.result,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: claimActions.js:93 ~ getClaimStats ~ error:",
      error
    );
    dispatch({
      type: CLAIM_STATS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getClaimsPending = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLAIM_PENDING_REQUEST,
    });

    const res = await ClaimsService.getIncompleteClaims();
    console.log("🚀 ~ file: claimActions.js:57 ~ getClaimsPending ~ res:", res);

    dispatch({
      type: CLAIM_PENDING_SUCCESS,
      payload: res.foundClaims,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: claimActions.js:64 ~ getClaimsPending ~ error:",
      error
    );
    dispatch({
      type: CLAIM_PENDING_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const claimPosting = (claim) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLAIM_POST_REQUEST,
    });

    const res = await ClaimsService.createClaim(claim);
    console.log("🚀 ~ file: claimActions.js:143 ~ claimPosting ~ res:", res);
    // dispatch(getClaimsList());
    // dispatch(getClaimStats());
    // dispatch(getClaimsPending());

    dispatch({
      type: CLAIM_POST_SUCCESS,
      payload: res,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: claimActions.js:150 ~ claimPosting ~ error:",
      error
    );
    dispatch({
      type: CLAIM_POST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const claimUpdating = (claim, claimId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLAIM_UPDATE_REQUEST,
    });

    const res = await ClaimsService.editClaim(claimId, claim);
    console.log("🚀 ~ file: claimActions.js:168 ~ claimUpdating ~ res:", res);
    dispatch(getClaimsList());
    dispatch(getClaimSingle(claimId));
    dispatch(getClaimStats());
    dispatch(getClaimsPending());

    dispatch({
      type: CLAIM_UPDATE_SUCCESS,
      payload: res,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: claimActions.js:175 ~ claimUpdating ~ error:",
      error
    );
    dispatch({
      type: CLAIM_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const claimDeleting = (claimId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLAIM_DELETE_REQUEST,
    });

    // const { adminLogin: { adminInfo } } = getState();

    // const config = {
    //   headers: {
    //     Authorization: adminInfo.token
    //   }
    // }

    const res = await axios.delete(
      `${REACT_APP_API_URL}/admin/claim/${claimId}`
    );

    dispatch({
      type: CLAIM_DELETE_SUCCESS,
      payload: res,
    });
  } catch (error) {
    dispatch({
      type: CLAIM_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};
